import { Divider, Flex } from '@chilipiper/design-system'
import React from 'react'
import { WorkingHours } from '@chilipiper/api-client-user-availability'
import { WorkingHoursDayRow } from '@/components/availability-schedules/working-hours/WorkingHoursDayRow'

interface Props {
  onChange: (workingHours: WorkingHours) => void
  workingHours: WorkingHours
}

export const WorkingHoursTable = ({ onChange, workingHours }: Props) => {
  return (
    <Flex flexDirection={'column'} w={'100%'}>
      {Object.entries(workingHours).map(([key, value], index) => {
        const isFirst = index === 0
        const isLast = index === Object.keys(workingHours).length - 1

        return (
          <React.Fragment key={key}>
            <WorkingHoursDayRow
              isFirst={isFirst}
              isLast={isLast}
              day={key}
              onChange={onChange}
              workIntervals={value}
              workingHours={workingHours}
            />
            {!isLast && <Divider />}
          </React.Fragment>
        )
      })}
    </Flex>
  )
}
